import fetchApi from "../fetchApi";

// Replaces the user's dynamic role assignment. roleIds is an array of role ids.
export const SetUserRoles = async (userId, roleIds) => {
  const options = {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({ role_ids: roleIds }),
    redirect: "follow",
  };

  return await fetchApi(`users/${userId}/roles`, options);
};
